module.exports = __webpack_public_path__ + "media/images/landings/promotion_5/img-campaign-pc@1.5x-c512a90a962c1a38671e0818d21dc429.png";